/* SPH – Wunsch-Reihenfolge Zubehör-Kategorien (wie stegplattenheld.de, Standardsortierung) */
(function () {
  var m = location.pathname.match(/\/collections\/([a-z0-9-]+)/);
  if (!m) return;
  var STEG = ['stegplatten-zubehor', 'stegplatten-zubehoer', 'zubehoer-profile-4-5-mm', 'zubehoer-profile-6-mm', 'zubehoer-profile-8-mm', 'zubehoer-profile-10-mm', 'zubehoer-profile-16-mm', 'zubehoer-profile-25-mm', 'zubehoer-profile-32-mm', 'regenrinne'];
  var WELL = ['wellplatten-zubehoer', 'wellplatten-zubehor', 'zubehoer-sinus-welle-76-18', 'zubehoer-sinus-130-30', 'zubehoer-sinus-177-51', 'zubehoer-trapez-70-18', 'zubehoer-trapez-76-18'];
  var ORDER;
  if (STEG.indexOf(m[1]) > -1) {
    ORDER = [
      ['verbindungsprofil-premium-alu-alu'],
      ['randprofil-premium-alu-alu'],
      ['verbindungsprofil-premium-alu-gummi'],
      ['randprofil-premium-alu-gummi'],
      ['universalprofil-alu-alu'],
      ['universalprofil-alu-gummi'],
      ['anti-dust-tape', '37'],
      ['anti-dust-tape', '43'],
      ['kantenschutz-16', 'mit-tropfkante'],
      ['kantenschutz-16', 'ohne-tropfkante'],
      ['klemmdeckel', 'weiss'],
      ['klemmdeckel', 'anthrazit'],
      ['klemmdeckel', 'silber'],
      ['wandanschlussprofil'],
      ['haltewinkel', 'pressblank'],
      ['spezial-silikon'],
      ['steckschl'],
      ['haltewinkel', 'weiss', '16'],
      ['haltewinkel', 'weiss', '10'],
      ['glashaltewinkel'],
      ['4-5x35'],
      ['6-3x32'],
      ['4-2x16'],
      ['5-5x34'],
      ['4-2x32'],
      ['5-5x58'],
      ['6-3x50'],
      ['6-3x64'],
      ['6-5x50'],
      ['6-5x75'],
      ['6-5x90'],
      ['klebeband-38'],
      ['klebeband-60'],
      ['dichtlippe'],
      ['eck-profil'],
      ['6-3x38'],
      ['mittelthermoprofil'],
      ['kantenschutz-25'],
      ['tropfnase', '!weiss'],
      ['tropfnase', 'weiss'],
      ['h-profil-4-5'],
      ['h-profil-10'],
      ['h-profil-16'],
      ['u-profil-transparent'],
      ['klemmprofil'],
      ['f-profil'],
      ['h-profil-aluminium'],
      ['firstprofil'],
      ['regenrinne-90'],
      ['regenrinne', 'anthrazit'],
      ['fallrohr', '!anthrazit'],
      ['fallrohr', 'anthrazit'],
      ['rinnenstutzen'],
      ['rinnenverbinder'],
      ['regenwasserklappe', '!anthrazit'],
      ['regenwasserklappe', 'anthrazit'],
      ['rohrbogen'],
      ['rohrschelle', '!anthrazit'],
      ['rohrschelle', 'anthrazit'],
      ['kunststoffmanschette'],
      ['rinnenendkappen']
    ];
  } else if (WELL.indexOf(m[1]) > -1) {
    ORDER = [
      ['spezial-silikon'],
      ['abstandhalter-p5'],
      ['abstandhalter-p8'],
      ['abstandhalter', 'trapez'],
      ['abstandhalter', 'sinus'],
      ['klebeband-60'],
      ['spenglerschrauben'],
      ['kalotten-', 'sinus'],
      ['kalotten-', 'trapez'],
      ['kalottenset', 'sinus'],
      ['kalottenset', 'trapez'],
      ['kegelbohrer'],
      ['profilfueller', 'sinus'],
      ['profilfueller', 'trapez'],
      ['sechskant'],
      ['steckschl']
    ];
  } else return;
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var mm = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i);
    return mm ? mm[1] : '';
  }
  function rank(h) {
    for (var i = 0; i < ORDER.length; i++) {
      var ok = true;
      for (var j = 0; j < ORDER[i].length; j++) {
        var p = ORDER[i][j];
        if (p.charAt(0) === '!') { if (h.indexOf(p.slice(1)) > -1) { ok = false; break; } }
        else if (h.indexOf(p) === -1) { ok = false; break; }
      }
      if (ok) return i;
    }
    return 999;
  }
  function apply() {
    var grid = document.querySelector('[data-sph-grid]');
    if (!grid || grid.dataset.sphZub) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
    if (!cards.length) return;
    grid.dataset.sphZub = '1';
    cards.forEach(function (c, idx) { c.dataset.zr = rank(handleOf(c)) * 1000 + idx; });
    cards.sort(function (a, b) { return a.dataset.zr - b.dataset.zr; });
    var empty = grid.querySelector('[data-sph-empty]');
    cards.forEach(function (c, idx) { c.dataset.i = idx + 1; grid.appendChild(c); });
    if (empty) grid.appendChild(empty);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
